import { FC, useCallback, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link, useNavigate } from "react-router-dom";

import FooterText from "../../components/footerText";
import ContactAndSafetyInfo from "../../components/contactAndSafetyInfo";
import { TextAlignProps } from "../../components/contactAndSafetyInfo/types";
import HubInputField from "../../components/inputType";

import { AuthContext } from "../../context/authContext";
import { ToastContext } from "../../context/toastContext";

import { LoginSchema } from "../../validation/login";
import useFetch from "../../hooks/useFetch";
import { AuthenticatedRoutes, PublicRoutes } from "src/routes/AppRoutes";

import { USER_TYPES } from "src/constants";
import { ProductBasedLogo } from "src/assets";
import { ToastTypes } from "../../types";
import { LoginAPIResponseType, LoginFormType } from "login";
import { APIEndpoints } from "../../types/apiTypes";
import { checkLandingPageExists } from "src/helpers";



const HubLogin: FC = (): JSX.Element => {
  const [isPasswordVisible, setPasswordVisibility] = useState<boolean>(false);

  const { control, handleSubmit } = useForm({
    mode: 'all',
    resolver: yupResolver(LoginSchema),
  });

  const { createSession, restoreSession } = useContext(AuthContext);
  const { showToast } = useContext(ToastContext);
  const navigate = useNavigate();



  const checkForAuthentication = useCallback(() => {
    const isAuthenticated = restoreSession();

    let indexRoute = null;
    if (isAuthenticated) {
      indexRoute = AuthenticatedRoutes.find((route) => route.isIndex);
      if (indexRoute) navigate(indexRoute.route);
    } else {
      indexRoute = PublicRoutes.find((route) => route.isIndex);
      if (indexRoute) navigate(indexRoute?.route);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    checkForAuthentication();
  }, [checkForAuthentication]);







  const { data: userData, loading, mutate, error, removeErrorAndData } =
    useFetch<LoginAPIResponseType>(APIEndpoints.USER_SIGNIN);

  useEffect(() => {
    console.log("Here I am, after logging in as rep and revisiting the login page")
    if (userData && userData.status.code === 200) {
      const { status, token } = userData;
      if (USER_TYPES.HCP.includes(status.data.user.ref_type)) {
        const resetDemoCases = status.data.account_dropdown['Reset Demo Cases']
        localStorage.setItem("resetDemoCases", JSON.stringify(resetDemoCases))
      }
      const landingPage =
        (USER_TYPES.MANUFACTURER.includes(status.data.user.ref_type) ?
          (status.data.navbar.landing_page && status.data.navbar.landing_page.default_view && status.data.navbar.landing_page.default_view !== "" ? status.data.navbar.landing_page.default_view : "todos_statistics")
          :
          (status.data.navbar.landing_page && status.data.navbar.landing_page.default_view && status.data.navbar.landing_page.default_view !== "" ? status.data.navbar.landing_page.default_view : "cases"));
      localStorage.setItem("landingPage", landingPage)
      //console.log(landingPage);
      const reinvestigation = status && status.data && status.data.navbar && status.data.navbar.reinvestigation
      localStorage.setItem("userEditDate",status.data.navbar.user_edit_date)
      createSession(
        status.data.user, status.data.sub_header, token, landingPage, reinvestigation === "1" || reinvestigation === true ? true : false, 
        status.data.navbar.eob_warehouse, status.data.navbar.upload_eob, status.data.navbar.cep_popup, 
        status.data.navbar.new_baa_user_1_2, status.data.navbar.outreach === "1" || status.data.navbar.outreach === true ? true : false, 
        status.data.navbar.pcc_outreach === "1" || status.data.navbar.pcc_outreach === true ? true : false
      );
      showToast([status.message], ToastTypes.SUCCESS);

      if (status.data.user.is_password_changed === false) {
         // console.log("here we are", "   ", status.data.user.id ,status.data.user.is_password_changed,`/users/${status.data.user.id}/edit`)

        navigate(`/users/${status.data.user.id}/edit`, { replace: true });
      } else if (USER_TYPES.MANUFACTURER.includes(status.data.user.ref_type)) {
         if (status.data.user.ref_type === "fad") {
          if (landingPage === "statistics") {
            navigate(`/${landingPage}`, { replace: true });
          } else {
              if (landingPage === "todos_statistics" || landingPage === "patient_statistics") {
            navigate(`/${landingPage}?id=${userData.status.data.user.id}&role=${userData.status.data.user.ref_type}`, { replace: true });
          }}
        }
        if (status.data.user.ref_type === "area_manager") {
          //console.log("area_manager")
          if (landingPage === "statistics") {
            navigate(`/areas/${userData.status.data.user.id}?id=${userData.status.data.user.id}&type=areas&role=area_manager`, { replace: true });
          } else {
              if (landingPage === "todos_statistics" || landingPage === "patient_statistics") {
            //console.log("Landing Page..... else if landingPage === todos_statistics || landingPage === patient_statistisc ", landingPage)
            navigate(`/${landingPage}?id=${userData.status.data.user.id}&role=${userData.status.data.user.ref_type}`, { replace: true });
          }}
        } else if (status.data.user.ref_type === "regional_manager") {
          if (landingPage === "statistics") {
            navigate(`/regions/${userData.status.data.user.id}?id=${userData.status.data.user.id}&type=regions&role=regional_manager`, { replace: true })
          } else {
            //navigate(`/${landingPage}?id=${userData.status.data.user.id}&role=regional_manager`)
            if (landingPage === "todos_statistics" || landingPage === "patient_statistics") {
              //console.log("Landing Page..... else if landingPage === todos_statistics || landingPage === patient_statistisc ", landingPage)
              navigate(`/${landingPage}?id=${userData.status.data.user.id}&role=${userData.status.data.user.ref_type}`, { replace: true });
            }
          }
        }
        else if (status.data.user.ref_type === "district_manager" ) {
          if (landingPage === "statistics") {
            navigate(`/district/${status.data.user.id}?id=${status.data.user.id}&type=district&role=${status.data.user.ref_type}`, { replace: true })
          } else {
            // //console.log("landingpage.....",landingPage)
            // navigate(`/${landingPage}?id=${userData.status.data.user.id}&role=district_manager`)
            if (landingPage === "todos_statistics" || landingPage === "patient_statistics") {
              //console.log("Landing Page..... else if landingPage === todos_statistics || landingPage === patient_statistisc ", landingPage)
              navigate(`/${landingPage}?id=${userData.status.data.user.id}&role=${userData.status.data.user.ref_type}`, { replace: true });
            }
          }
        } else if (status.data.user.ref_type === "rep") {
          // if (landingPage === "statistics") {
          // navigate(`/${"patient_statistics"}?id=${userData.status.data.user.id}&role=${userData.status.data.user.ref_type}`, { replace: true });

          //   // navigate(`/territories/${userData.status.data.user.id}?id=${userData.status.data.user.id}&role=rep&type=territories`, { replace: true })
          // } else {
          //   if (landingPage === "todos_statistics" || landingPage === "patient_statistics") {
          //     //console.log("Landing Page..... else if landingPage === todos_statistics || landingPage === patient_statistisc ", landingPage)
          // navigate(`/${"patient_statistics"}?id=${userData.status.data.user.id}&role=${userData.status.data.user.ref_type}`, { replace: true });
          //   }
            //navigate(`/${landingPage}/${userData.status.data.user.id}?id=${userData.status.data.user.id}&role=rep&type=territories`)
          navigate(`/${"patient_statistics"}?id=${userData.status.data.user.id}&role=${userData.status.data.user.ref_type}`, { replace: true });
          // }
        } else if (landingPage === "todos_statistics" || landingPage === "patient_statistics") {
          //console.log("Landing Page..... else if landingPage === todos_statistics || landingPage === patient_statistisc ", landingPage)
          navigate(`/${landingPage}?id=${userData.status.data.user.id}&role=${userData.status.data.user.ref_type}`, { replace: true });
        } else {
          checkLandingPageExists(userData.status.data.user.ref_type, landingPage) ? navigate(`/${landingPage}`, { replace: true }) : navigate(`/${'todos_statistics'}`, { replace: true });
        }
      } else if (USER_TYPES.HCP.includes(status.data.user.ref_type)) {
        //console.log(USER_TYPES.HCP.includes(status.data.user.ref_type),landingPage ,checkLandingPageExists(userData.status.data.user.ref_type,landingPage) )
        checkLandingPageExists(userData.status.data.user.ref_type, landingPage) ? navigate(`/${landingPage}`, { replace: true }) : navigate(`/${'cases'}?id=${userData.status.data.user.id}&role=${userData.status.data.user.ref_type}`, { replace: true });
      } else {
        navigate(`/users/sign_in`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  useEffect(() => {
    if (error) {
      const errorMsg =
        error === "Provided email and password is not correct"
          ? "Invalid Email or password"
          : error || "Something went wrong. Please try again later.";
  
      showToast([errorMsg], ToastTypes.ERROR);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);
  

  const submitForm = async (values: LoginFormType) => {
    if ((error && error.length > 0) || userData) removeErrorAndData();

    mutate({ user: values });
  };




  return (
    <div className="login-sec mt-0 mt-sm-0 mt-md-0 mt-lg-0 mt-xl-5 d-flex flex-fill flex-column overflow-auto">
      <div className="container-fluid p-0">
        <div className="container container-full">
          <div className="my-3">
            <ContactAndSafetyInfo alignText={TextAlignProps.TEXT_END} textColor="black" />
          </div>

          <div className="row">
            <div className="col-12 col-md-6">
              <h1 className="login-text text-primary">
                My QUTENZA Connect answers questions about treatment access and support.
              </h1>
            </div>

            <div className="col-12 col-md-2 d-none d-lg-block"></div>

            <div className="col-12 col-md-4 flex-fill">
              <form onSubmit={handleSubmit(submitForm)}>
                <h2 className="mb-3">Sign in</h2>

                <div className="mb-3 mb-md-5">
                  <Controller
                    name="email"
                    control={control}
                    defaultValue=''
                    render={({ field, fieldState: { error } }) => (
                      <HubInputField
                        inputId="email"
                        isRowBased={false}
                        isRequired={true}
                        field={field}
                        error={error}
                        inputType="email"
                        inputPlaceholder="Email"
                      />
                    )}
                  />
                </div>
                <div className="mb-4">
                  <Controller
                    name="password"
                    control={control}
                    defaultValue=''
                    render={({ field, fieldState: { error } }) => (
                      <div className="mb-3">
                        <div className="input-group">
                          <input type={isPasswordVisible ? "text" : "password"} placeholder="Password"
                            className="form-control" {...field} />
                          <span className="input-group-text p-0">
                            <button className="btn" type="button"
                              onClick={() => setPasswordVisibility((isPasswordVisible) => !isPasswordVisible)}
                            >
                              {isPasswordVisible ? (
                                <i className="bi bi-eye-fill"></i>
                              ) : (
                                <i className="bi bi-eye-slash"></i>
                              )}
                            </button>
                          </span>
                        </div>

                        {error && (<p className="m-0 mt-2 text-danger">{error.message}</p>)}
                        {/* {error && error.message === 'Password does not meet requirements' ? (
                          <ul className="m-0 mt-2 text-danger">
                            <li>Length should be at least 10</li>
                            <li>Must contain at least 1 lowercase letter</li>
                            <li>Must contain at least 1 uppercase letter</li>
                            <li>Must contain at least 1 number</li>
                            <li>Can contain special character</li>
                          </ul>
                        ) : (
                          error && <p className="text-red-500 text-sm mt-1">{error.message}</p>
                        )} */}
                      </div>
                    )}
                  />
                </div>

                <div className="row align-items-center">
                  <div className="col-auto">
                    <button disabled={loading} className="btn btn-warning btn-lg" type="submit">
                      {loading ? (<i className="spinner-border me-2"></i>) : null}
                      Log in
                    </button>
                  </div>
                  <div className="col-auto">
                    <Link to="/users/password/new">Forgot your password?</Link>
                  </div>
                </div>
              </form>

              <div className="mt-3 d-flex justify-content-end">
                <img src={ProductBasedLogo} height="80" alt="Product Logo" />
              </div>
            </div>
          </div>
        </div>

        <div className="curve-bg"></div>

        <div className="bg-white">
          <div className="container container-full"><FooterText /></div>
        </div>
      </div>
    </div>
  );
};

export default HubLogin;


